module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "page",
      _vm.appPage.classes,
      {
        'page--is-loaded': _vm.appState.loaded,
      } ],
    attrs: {
      "id": "app",
      "data-env": _vm.appEnv
    }
  }, [_c('ui-header'), _vm._v(" "), (_vm.getLocalStoreLocalStoreUp) ? void 0 : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loader",
      "mode": "out-in"
    },
    on: {
      "appear": function($event) {
        return _vm.onLoad()
      },
      "enter": function($event) {
        return _vm.onLoad()
      },
      "leave": function($event) {
        return _vm.onLeave()
      }
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _vm._v(" "), (!_vm.$route.meta.hideFooter) ? _c('ui-footer-legal', {
    attrs: {
      "footer": _vm.footer
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-loader')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c72f41a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 287
// module chunks = 2